module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/school5-4cb7459d01dbde5c0d8da2b15b5ca40e.svg";